import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import ShopBalanceService from '../services/ShopBalanceService';

const initialState = {
    shopId: null,
    shopName: null,
    items: [],
    loading: false,
    error: null,
};

export const fetchShopBalanceByShop = createAsyncThunk(
    'shopBalance/by-shop',
    async (params, { rejectWithValue }) => {
        try {
            const resp = await ShopBalanceService.ShopBalanceByShop(params);
            return resp;
        } catch (e) {
            return rejectWithValue(e.response);
        }
    },
);

const shopBalanceSlice = createSlice({
    name: 'shopBalance',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchShopBalanceByShop.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchShopBalanceByShop.fulfilled, (state, action) => {
                if (action.payload?.status === 200) {
                    const data = action.payload?.data?.data || {};
                    state.shopId = data.shop_id ?? null;
                    state.shopName = data.shop_name ?? null;
                    state.items = data.items || [];
                } else {
                    state.error = action.payload?.data?.message;
                    toast.error(state.error);
                }
                state.loading = false;
            })
            .addCase(fetchShopBalanceByShop.rejected, (state, action) => {
                state.error = action.payload?.data;
                state.loading = false;
            });
    },
});

export default shopBalanceSlice.reducer;
